export const DEX_TRANSFER_WIDGET_TYPE_ID = 'DexTransferWidget';
